import { render, staticRenderFns } from "./newspaper.vue?vue&type=template&id=5baa8858&scoped=true&"
import script from "./newspaper.vue?vue&type=script&lang=js&"
export * from "./newspaper.vue?vue&type=script&lang=js&"
import style0 from "./newspaper.vue?vue&type=style&index=0&id=5baa8858&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baa8858",
  null
  
)

export default component.exports